import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-terms-dialog',
  templateUrl: './terms-dialog.component.html',
})
export class TermsDialogComponent {
  @Input() visible = false;
  @Input() pdfUrl: string | null = null;

  @Output() accepted = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  accept(): void {
    this.accepted.emit();
    this.visible = false;
  }

  onClose(): void {
    this.closed.emit();
  }
}
